module.exports = __webpack_public_path__ + "static/dp-princip-2-6b00e50e22f1444c7431c9ff77808fb3.svg";